var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.598982,
    d: "M13.9166 3.19958L12.1666 0.282916C12.0611 0.107414 11.8714 0 11.6667 0H2.33334C2.1286 0 1.93886 0.107414 1.83342 0.282916L0.0834238 3.19958C0.0288764 3.29029 3.65816e-06 3.39414 3.65816e-06 3.49999C-0.00225067 4.78572 1.0377 5.8301 2.32342 5.83332H2.32809C2.90427 5.83479 3.46035 5.62164 3.88792 5.23541C4.77106 6.0336 6.1151 6.0336 6.99824 5.23541C7.88183 6.03536 9.2279 6.03536 10.1115 5.23541C10.7955 5.85251 11.7791 6.00833 12.6204 5.63287C13.4617 5.2574 14.0025 4.42126 14 3.49999C14 3.39414 13.9711 3.29029 13.9166 3.19958Z",
    fill: "#8A8FAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.676 6.69952C11.1337 6.69998 10.5988 6.55763 10.1132 6.28366L10.1045 6.2883C9.27663 6.75687 8.31822 6.83077 7.44216 6.49358C7.29043 6.43567 7.14231 6.3662 6.99882 6.28565L6.99241 6.28896C6.16481 6.75786 5.20639 6.83153 4.33066 6.49358C4.17912 6.43566 4.0312 6.3662 3.88791 6.28565C3.40322 6.55886 2.86924 6.70054 2.32808 6.69952C2.13429 6.69742 1.94096 6.67749 1.75 6.63992V13.3215C1.75 13.6872 2.01117 13.9836 2.33333 13.9836H5.83333V10.0105H8.16666V13.9836H11.6666C11.9888 13.9836 12.25 13.6872 12.25 13.3215V6.63727C12.0605 6.67581 11.8685 6.69663 11.676 6.69952Z",
    fill: "#3A416F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.7627318622dbf5de946e47ba57c4c444.svg";
export { ForwardRef as ReactComponent };